/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsSignUpResponse } from './RevisdomAPIViewModelsSignUpResponse';
import {
    RevisdomAPIViewModelsSignUpResponseFromJSON,
    RevisdomAPIViewModelsSignUpResponseFromJSONTyped,
    RevisdomAPIViewModelsSignUpResponseToJSON,
    RevisdomAPIViewModelsSignUpResponseToJSONTyped,
} from './RevisdomAPIViewModelsSignUpResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1SignUpResponse
 */
export interface ApiResponse1SignUpResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1SignUpResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1SignUpResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsSignUpResponse}
     * @memberof ApiResponse1SignUpResponse
     */
    data?: RevisdomAPIViewModelsSignUpResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1SignUpResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1SignUpResponse interface.
 */
export function instanceOfApiResponse1SignUpResponse(value: object): value is ApiResponse1SignUpResponse {
    return true;
}

export function ApiResponse1SignUpResponseFromJSON(json: any): ApiResponse1SignUpResponse {
    return ApiResponse1SignUpResponseFromJSONTyped(json, false);
}

export function ApiResponse1SignUpResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1SignUpResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsSignUpResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1SignUpResponseToJSON(json: any): ApiResponse1SignUpResponse {
    return ApiResponse1SignUpResponseToJSONTyped(json, false);
}

export function ApiResponse1SignUpResponseToJSONTyped(value?: ApiResponse1SignUpResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsSignUpResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

